import component from "./ProfileExtraInfo.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileExtraInfo"

export default wrapVueComponent(componentName, component)
